import React, {
    useEffect,
    useState,
    useRef,
    forwardRef,
    useImperativeHandle,
  } from "react";
  import {
    Box,
    Text,
    RadioGroup,
    Stack,
    Heading,
    Checkbox,
    Divider,
    InputGroup,
    Input,
    InputRightElement,
    Radio,
    CheckboxGroup,
    Image,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Textarea,
    Flex,
  } from "@chakra-ui/react";
  import ModalRight from "../../modal-right";
  import SearchBar from "../../search-bar";
  import PrimaryButton from "../../primary-button";
  import PrimaryInput from "../../primary-input";
  import DatePicker from "../../date-picker";
import MonthYearPicker from "../../date-monthyear";
  import {
    addMedicalConditions,
    getmedicalcondition,
  } from "../../../middleware/services/messages";
  import { format } from "date-fns";
  import { actionAccessMain, getDob, getgender, getusername, handleAlphaDotAndSpace, validationOfNumberWithOnly1Decimal } from "../../../auth";
  import DatePickerQuick from "../date-picker-quick";
import { AddMedicine, FetchMedicationsData, GetAIMedicineComposition, GetMedicineName } from "../../../middleware/services/medications.js";
import MiniDropdownInput from "../../mini-dropdown/index.js";
import DropdownInput from "../../dropdown-input/index.js";
import moment from "moment";
import { COLORS } from "../../styles/colors/index.js";
import { Button } from "react-day-picker";
import { uploadImageInProfile } from "../../../middleware/services/profile/index.js";
import DropdownInputForVitals from "../../dropdown-input-forVitals/index.js";
import { languageCodeMap, languageOptions } from "../../language-dropdown/index.js";
import { useHybridTranscriber } from "../doctor-notes/cheif-complaint-audio/useHybridTranscriber.js";
import { useForm } from "react-hook-form";
import { CorrectMedicalTermsUsingAI } from "../../../middleware/services/visits/aicalls.js";
import DropdownWithMultiLingual from "../../dropdown-multilingual/index.js";
import { GPUChatAudioManagerSpeechMode } from "../doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode.js";
import { AudioDisplayForClutter } from "../doctor-notes/notes-transcription/utils/audio-display-multi-lingual.js";

  
  const NoMedicationDataScreen = forwardRef(
    (
      {
        width,
        height,
        patientId,
        showErrorToast,
        showSuccessToast,
        showLoader,
        dismissLoader,
        fetchPatientHealthData,
        isNoData,
      },
      ref
    ) => {
      const openFromStartVisitOverview = () => {
        console.log("Function called!");
        openAddMedicationModal();
      };
  
      useImperativeHandle(ref, () => ({
        openFromStartVisitOverview,
      }));
  
      const [actionAccessPatients, setActionAccessPatients] = useState(null);
      useEffect(() => {
        setActionAccessPatients(actionAccessMain(3));
      }, []);

      const addmedications = React.useRef();
          const showmedicinename = React.useRef();
      
  
      const handleAlphaNumericDotAndSpace = (value) => {
        return value.replace(/[^0-9a-zA-Z\s.]/g, "");
      };

    //   ----------------------------------- Medication Fucntionality starts -----------
    // const { isLoading, showLoader, dismissLoader } = useLoader();
    var [data, setData] = useState(null);
//   const { showSuccessToast, showErrorToast } = Toaster();
//   const location = useLocation();
  const [patientid, setPatientid] = useState("");
    const [  boolCheck , setBoolCheck ] = useState(false)
  const [  initialPageLoad , setInitialPageLoad ] = useState(false)
  const [isChecked , setIsChecked] = useState(0)
  const [medicineexpirydate, setMedicineExpiryDate] = useState('');
  var [title, setTitle] = useState();
  const [showhidesearch, ShowHideSearch] = useState(false);

  const [minDateStateEdit , setMinDateStateEdit] = useState('')
  const [maxDateStateEdit , setMaxDateStateEdit] = useState('')
  var [id, setID] = useState();
  const [showAIModal , setShowAIModal] = useState(true)
  const [daysDiffrence, setDaysDiffrence] = useState("")
  const [documentURLForEdit, setDocumentURLForEdit] = useState([]);
  const [showDocNamesDropdown , setShowDocNamesDropdown] = useState(true)
  const [searchValue, setSearchValue] = useState("");
  const [boolValForSuggestions , setBoolValForSuggestions] = useState(true)
  const [suggestions, setSuggestions] = useState({});
  const [treatmentteamdata, setTreatmentTeamData] = useState("");
  const [benifit, setBenifit] = useState('')
  const [sideEffects, setSideEffects] = useState('')


  const [filenameforUpload, setFilenameforUpload] = useState([])
    const [selectedImage, setSelectedImage] = useState(null);
  const today = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
  const [prescribedby, setPrescribedBy] = useState(null);
  const [hospitalname, setHospitalname] = useState(null);
  const [medicinename, setMedicineName] = useState("");
  const [Composition, setComposition] = useState("");
  const [medicinedata, setMedicinedata] = useState(null);
  //const [medicineenddata, setMedicineEndDate] = useState('');
  const [dosage, setMedicineDosage] = useState(null);
  const [dosageunit, setMedicineDosageUnit] = useState("mg");
  const [frequency, setMedicineDosageFrequency] = useState("1");
  const [morning, setMorning] = useState("0");
  const [afternoon, setAfternoon] = useState("0");
  const [setevening, setEvening] = useState("0");
  const [setnight, setNight] = useState("0");
  const [beforefood, setBeforefood] = useState("0");
  const [afterfood, setAfterfood] = useState("0");
  const [filenameArray, setFilenameArray] = useState([]);


  const [activeTab, setActiveTab] = useState(0);
  const [medicineData, setMedicineData] = useState([])
  const [medicineTypeRadio, setMedicineTypeRadio] = useState("Tablet")
  const [medicinetypeFilter, setMedicineTypeFilter] = useState("All")
  const [medicinetype, setMedicineType] = useState("Tablet");
  const [filteredData, setFilteredData] = useState([]);


  const [aianswers, setAIAnswers] = useState([]);
  const [remainingquestions, setRemainingQuestions] = useState([]);
  const [aiquestion, setAIAnalysis] = useState(null);
  const [AiInput, setAiInput] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [animate, setAnimate] = useState(false);  

   // states of new inputs of medication ---
    const [routeOfAdministration, setRouteOfAdministration] = useState(null);
    const [timing, setTiming] = useState(null);
    const [quantity, setQuantity] = useState(null);
    const [areaOfApplication, setAreaOfApplication] = useState(null);
    const [diluent, setDiluent] = useState(null);
    const [infusionDuration, setInfusionDuration] = useState(null);
    const [infusionFrequency, setInfusionFrequency] = useState(null);
    const [additives, setAdditives] = useState(null);
    const [duration, setDuration] = useState(null);
  
    const [medicineFreqValue, setMedicineFreqValue] = useState(null)
    const [medicineFreqUnit, setMedicineFreqUnit] = useState("")
    //   const [ durationValue , setDurationValue] = useState("")
    //   const [ durationUnit , setDurationUnit] = useState("")
  
    const [rateOfInfusionValue, setRateOfInfusionValue] = useState(null);
    const [rateOfInfusionUnit , setRateOfInfusionUnit] = useState("ml/hr")
    const [durationValue, setDurationValue] = useState("5");
    const [durationUnit, setDurationUnit] = useState("Days");
    const [frequencyUnit, setFrequencyUnit] = useState(null);


    const fetchmedicationdata = async () => {
        showLoader()
            try {
              const result = await FetchMedicationsData({
                //patientid: id,
                "patientid":patientId,
              });
    
              console.log('result: ', result)
              if (result != null) {
                setData(result);
                setFilteredData(result)
              } else {
                setFilteredData('')
              }
              dismissLoader()
          } catch (error) {
              console.error("Error in home:", error);
            }
            dismissLoader()
          };

          // useEffect(() => {
          //   // fetchData("All", 1);
          //   fetchmedicationdata();
          // }, []);

          useEffect(()=>{
              setBoolValForSuggestions(!boolValForSuggestions)
            },[suggestions])
            const fetchData = async (type, tab) => {
              showLoader();
              setData("");
              try {
                const result = await FetchMedicationsData({
                  // patientid,
                  "patientid":patientId,
                  medicinetype: type,
                  // iscurrent: tab,
                });
                //console.log(result, "modified medications res");
                if (result != null) {
                  setData(result);
                  setFilteredData(result)
                } else {
                  //alert("No data");
                }
                dismissLoader();
              } catch (error) {
                console.error("Error in DashboardIndex:", error);
              }
            };

          let patientgender = getgender();
          let gender = patientgender;
          if (gender === 1) {
            gender = "Female";
          } else if (gender === 2) {
            gender = "Male";
          } else if (gender === 3) {
            gender = "Others";
          }else{
            gender = "Male";
          }
            const dob = getDob();
            const patientname = getusername();
          
            const age = calculateAge(dob);
            function calculateAge(dateOfBirth) {
              const today = new Date();
              const dob = new Date(dateOfBirth);
              let age = today.getFullYear() - dob.getFullYear();
              const monthDiff = today.getMonth() - dob.getMonth();
          
              if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
                age--;
              }
              return age;
            }
            // const handlemedicinetime = (values) => {
            //   if (values.includes("morning")) {
            //     setMorning(1);
            //   } else {
            //     setMorning(0);
            //   }
            //   if (values.includes("afternoon")) {
            //     setAfternoon(1);
            //   } else {
            //     setAfternoon(0);
            //   }
            //   if (values.includes("evening")) {
            //     setEvening(1);
            //   } else {
            //     setEvening(0);
            //   }
            
            //   if (values.includes("night")) {
            //     setNight(1);
            //   } else {
            //     setNight(0);
            //   }
            // };
            
            // const [timeValues, setTimeValues] = useState(["morning"]);
            const [timeValues, setTimeValues] = useState([]);
            const handlemedicinetime = (values) => {
              
              // If any time checkbox is selected, clear frequency inputs
              if (values.length > timeValues.length) {
                // if (values.length > 0) {
                  setMedicineFreqUnit("");
                  setMedicineFreqValue(null);
                }
                setTimeValues(values);
              
              // Update individual time states if needed
              setMorning(values.includes("morning") ? 1 : 0);
              setAfternoon(values.includes("afternoon") ? 1 : 0);
              setNight(values.includes("night") ? 1 : 0);
            };

            // const [foodTiming, setFoodTiming] = useState("beforefood"); 
            const [foodTiming, setFoodTiming] = useState(""); 
            // const handlemedicinetimebeforeafter = (values) => {
            //   if (values.includes("beforefood")) {
            //     setBeforefood(1);
            //   } else {
            //     setBeforefood(0);
            //   }
            
            //   if (values.includes("afterfood")) {
            //     setAfterfood(1);
            //   } else {
            //     setAfterfood(0);
            //   }
            // };

            const handlemedicinetimebeforeafter = (value) => {
              setFoodTiming(value);
              if (value === "beforefood") {
                setBeforefood(1);
                setAfterfood(0);
              } else {
                setBeforefood(0);
                setAfterfood(1);
              }
            };
          
            const filterSurgeonNames = (surgeonName) => {
              const filtered = treatmentteamdata && treatmentteamdata.filter((surgeon) =>
                surgeon.doctorname?.toLowerCase().includes(surgeonName.toLowerCase())
              );
              setSuggestions(filtered);
            };
          
            const handleSurgeonNameChange = (surgeonName) => {
              let formattedValue = surgeonName.replace(/[^0-9a-zA-Z\s.]/g, "")
              setPrescribedBy(formattedValue);
          
              // Filter surgeon names based on input
              if (formattedValue) {
                filterSurgeonNames(formattedValue);
              } else {
                setSuggestions([]);
              }
              setPrescribedBy(formattedValue)
            };
          
            const handleSelect = (suggestion) => {
              setPrescribedBy(suggestion.doctorname);
              setSuggestions([]);
            };
            let input = {
              // patientid: "",
              "patientid":patientId,
              documenttype_cd: "",
              documentcategory_cd: "",
              documentname: "",
              documenturl: "",
              prescribedby: prescribedby,
              hospitalname: hospitalname,
              patientname: patientname,
              age: age,
              documentdate: today,
              medicinedetail: [
                {
                  medicinename: medicinename,
                  chemical_composition: Composition,
                  medicinetype: medicinetype,
                  dosage: dosage,
                  dosageunit:dosageunit,
                  // startdate: fromdate,
                  // enddate: todate,
                  frequency: frequency || "1",
                  frequencytime: medicineFreqUnit,
                  frequencyvalue: medicineFreqValue || null,
                  // frequency:   frequency && medicineFreqUnit ? (frequency + " " + medicineFreqUnit) : frequency,
                  morning: morning,
                  afternoon: afternoon,
                  // evening: setevening,
                  evening: afternoon,
                  night: setnight,
                  beforefood: beforefood,
                  afterfood: afterfood,
                  medicineexpirydate: medicineexpirydate,
                  iscurrentmedicine: isChecked,
                  longtext: "",
                  documents: filenameArray.map(filename => ({ filename })),
          
                   // new inputs
                   "routeofadministration": routeOfAdministration,
                   "timingofinjection": timing,
                   "quantitytobeapplied": quantity,
                   "areaofapplication": areaOfApplication,
                   "diluent": diluent,
                   "additives": additives,
           
                   "rateofinfusionvalue": rateOfInfusionValue,
                   "rateofinfusionunit": rateOfInfusionUnit,
                   "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue || "5 Days",
                },
              ],
            };
          
            const handleimageselection = async (e) => {
              e.preventDefault();
              setMedicineName("")
              const file = e.target.files[0];
              const reader = new FileReader();
              reader.onloadend = () => {
                setSelectedImage(reader.result);
              };
              reader.readAsDataURL(file);
              const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
              if (!allowedTypes.includes(file.type)) {
                showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
              dismissLoader();
                return false;
              }
              showLoader();
              const result = await GetMedicineName(file, file.name, file.type);
              if(result?.output?.message  == "No credits are available"){
                showErrorToast("No sufficient tokens available")
              }else{
              setMedicineName(result.medicine_name);
              setComposition(result.chemical_composition)
          
               if(result.expiry_date !== "00-0000"){
                //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
                setMedicineExpiryDate(result.expiry_date);
               }
              setBenifit(result.benefit);
              setSideEffects(result.side_effects);
            //  showmedicinename.current.openRight();
              }
              
              
            e.target.value = '';
              dismissLoader();
            };
          
          
            const handlemedicinenamecontinue = () => {
              showmedicinename.current.closeRight();
              
            };
          
            // Add Medicine
            const addmedicine = async () => {
              // const parsedDate = moment(medicineexpirydate, "MM-yyyy");
              // const mfgMonth = parsedDate.month() +1;
              // const mfgYear = parsedDate.year();
              const currentMonth = moment().month() + 1;
              const currentYear = moment().year();
          
              const parsedDateExp = moment(medicineexpirydate, "MM-yyyy");
              const expMonth = parsedDateExp.month() +1;
              const expYear = parsedDateExp.year();
              
              showLoader();
              if (moment(input.medicinedetail[0].startdate, 'DD-MM-YYYY', true).isValid()) {
              input.medicinedetail[0].startdate = moment(input.medicinedetail[0].startdate, 'DD-MM-YYYY').format('YYYY-MM-DD');
              }
              if (moment(input.medicinedetail[0].enddate, 'DD-MM-YYYY', true).isValid()) {
              input.medicinedetail[0].enddate = moment(input.medicinedetail[0].enddate, 'DD-MM-YYYY').format('YYYY-MM-DD');
              }
              //console.log(input , " input to add medictiaon")
              //Freq and duration validations in Add Func ---
              //  if (medicineFreqUnit && !frequency) {
              //     showErrorToast("Please select Frequency Value!");
              //     dismissLoader();
              //     return false;
              //   } else if (!medicineFreqUnit && frequency) {
              //     showErrorToast("Please select Frequency Interval!");
              //     dismissLoader();
              //     return false;
               if (medicineFreqUnit && !medicineFreqValue) {
                  showErrorToast("Please select Frequency Value!");
                  dismissLoader();
                  return false;
                } else if (!medicineFreqUnit && medicineFreqValue) {
                  showErrorToast("Please select Frequency!");
                  dismissLoader();
                  return false;
                } else if (!durationUnit && durationValue && (medicinetype != "Syrup" && medicinetype != "Drops")) {
                  showErrorToast("Please select Duration!");
                  dismissLoader();
                  return false;
                } else if (durationUnit && !durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
                  showErrorToast("Please select Interval Value!");
                  dismissLoader();
                  return false;
                }
              //---
          
              if (medicinename == "") {
                showErrorToast("Please specify or upload any medicine");
                setTimeout(() => {
                dismissLoader();
                }, 1000);
                return false;
              }else if(medicineexpirydate && expYear == currentYear && expMonth < currentMonth){
                showErrorToast("Exp month cannot be less than current Month!");
                dismissLoader();
                  return false;
              } else {
                const result = await AddMedicine(input);
                // console.log('medicationsNoScreen: ', result)
                
                if (result && result.output.result === 'success') {
                  showSuccessToast("Medicine created Successfully");
                  // fetchData(medicinetypeFilter, activeTab === 1? "0": "1");
                  fetchPatientHealthData();
                  addmedications.current.closeRight();
                  // defaultStates();
                } else if (result.output.result === "failure" && result.output.message ==="medicine already Exists") {
                  showErrorToast("Medicine already Exists")
                }
              }
              dismissLoader();
            };

             const fetchComposition = async (medicineName) => {
                const inputData = {
                  input: {
                    name: medicineName,
                  },
                };
                if(medicineName){
                try {
                   showLoader();
                  const result = await GetAIMedicineComposition(inputData.input);
                  // console.log(result);
                  if (result) {
                    showSuccessToast("Medicine composition fetched successfully");
                    setComposition(result.chemical_composition);
                    // setMedicineExpiryDate(result.expiry_date);
                    setBenifit(result.benefit);
                setSideEffects(result.side_effects);
                  }
                  dismissLoader()
                } catch (error) {
                  console.error("Error Fetching Medicine composition:", error);
                  showErrorToast("An error occurred while Fetching Medicine composition");
                } 
                  
              }else{
                showErrorToast("Please provide medicine name or upload medicine photo")
              }
              };

              const makeAicall = async ()=>{
                  const inputData = {
                    input: {
                      name: medicinename,
                    },
                  };
                  if(medicinename){
                  try {
                   showLoader();
                  const result = await GetAIMedicineComposition(inputData.input);
                  if(result){
                      // setMedicineName(result.medicine_name);
                      setComposition(result.chemical_composition)
              
                      if(result.expiry_date !== "00-0000"){
                        //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
                        setMedicineExpiryDate(result.expiry_date);
                      }
                      setBenifit(result.benefit);
                      setSideEffects(result.side_effects);
                    //   learnMoreModal.current.openModal()
                       dismissLoader();
                  }
                  }catch(error){
              
                  }
                }
              };

              const [dropdownMedType, setDropdownMedType] = useState("");
                    const [selectedValue, setSelectedValue] = useState("");
                    
                    const additionalMedicineTypes = [
                      "Respules",
                      "Suspension",
                      "Foam",
                      "Suppository",
                      "EA",
                      "Device",
                      "Box",
                      "Spray",
                      "Lotion",
                      "Tube",
                      "Gargle",
                      "Powder",
                      "Soap",
                      "Aerosol",
                      "Shampoo",
                      "Topical Cleanser",
                      "Custom"
                    ];
                    
                    const handleDropdownMedTypeChange = (value) => {
                      setMedicineType("");
                      setDropdownMedType(value);
                      setSelectedValue(value);
                      handlemedicinetypechange(value);
                    };
                      const handlemedicinetypechange = (event, type = "") => {
                        setMedicineType(event);
                        setDropdownMedType("");
                        setSelectedValue(event);
                        // if(type == "filter"){
                        //   setFilterMedicinetype(event);
                        // }
                        if(event == "Tablet" || event == "Capsule" || event == "Suppository" || event == "Sachet" || event == "Powder"){
                          setMedicineDosageUnit("mg");
                        }
                        else if (event == "Syrup" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids" || event == "Drops" || event == "Suspension" || event == "Respules" || event == "Gargle" || event == "Shampoo" || event == "Topical Cleanser"){
                          setMedicineDosageUnit("ml");
                        }
                        else if (event == "Ointment" || event == "Cream" || event == "Gel" || event == "Foam" || event == "Lotion" || event == "Tube" || event == "Soap"){
                          setMedicineDosageUnit("grms");
                        }
                        else if (event == "Inhaler" || event == "Spray" || event == "Aerosol"){
                          setMedicineDosageUnit("puffs");
                        }
                        else if (event == "EA" || event == "Device" || event == "Box"){
                          setMedicineDosageUnit("each");
                        }
                        else if (event == "Custom"){
                          // For custom, you might want to set a default or leave it empty
                          setMedicineDosageUnit("");
                        }
                    };

//               const handlemedicinetypechange = (event, type) => {
//     setMedicineType(event);
//     // if(type == "filter"){
//     //   setFilterMedicinetype(event);
//     // }
//     if(event == "Tablet" || event == "Capsule" || event == "Suppository" || event == "Sachet" || event == "Powder"){
//       setMedicineDosageUnit("mg");
//     }
//     else if (event == "Syrup" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids" || event == "Drops" || event == "Suspension" || event == "Respules" || event == "Gargle" || event == "Shampoo" || event == "Topical Cleanser"){
//       setMedicineDosageUnit("ml");
//     }
//     else if (event == "Ointment" || event == "Cream" || event == "Gel" || event == "Foam" || event == "Lotion" || event == "Tube" || event == "Soap"){
//       setMedicineDosageUnit("grms");
//     }
//     else if (event == "Inhaler" || event == "Spray" || event == "Aerosol"){
//       setMedicineDosageUnit("puffs");
//     }
//     else if (event == "EA" || event == "Device" || event == "Box"){
//       setMedicineDosageUnit("each");
//     }
//     else if (event == "Custom"){
//       // For custom, you might want to set a default or leave it empty
//       setMedicineDosageUnit("");
//     }
// };
              // existing function
              // const handlemedicinetypechange = (event) => {

              //   setMedicineType(event);
              //   if(event == "Tablet" || event == "Capsule"){
              //     setMedicineDosageUnit("mg");
              //   }else if (event == "Syrup" || event == "Drops" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids"){
                  
              //     setMedicineDosageUnit("ml");
              //   }else if (event == "Ointment"){
                  
              //     setMedicineDosageUnit("grms");
              //   }else if (event == "Inhaler"){
              //     setMedicineDosageUnit("puffs")
              //   }
              // };

              const handleChangeDosageUnit = (selectedOption) => {
                setMedicineDosageUnit(selectedOption.label);
              };

              const handleRateOfInfusionUnit = (selectedOption) => {
                setRateOfInfusionUnit(selectedOption.label);
              };
              
               function handleFrequencyUnit(selectedOption) {
                 
                 if (selectedOption) {
                   setTimeValues([]);
                   setMorning(0);
                   setAfternoon(0);
                   setNight(0);
                  }
                  setMedicineFreqUnit(selectedOption)
              }
               function handleFrequencyValue(selectedOption) {
                 
                 // If frequency value is selected, clear time checkboxes
                 if (selectedOption) {
                   setTimeValues([]);
                   setMorning(0);
                   setAfternoon(0);
                   setNight(0);
                  }
                  setMedicineFreqValue(selectedOption)
              }

              // Add this effect to handle manual input in frequency value
useEffect(() => {
  if (medicineFreqValue) {
    setTimeValues([]);
    setMorning(0);
    setAfternoon(0);
    setNight(0);
  }
}, [medicineFreqValue]);
              function handleDurationValue(selectedOption) {
                  setDurationValue(selectedOption)
              }
              function handleDurationUnit(selectedOption) {
                // if(selectedOption != "Until symptoms resolve"){
                  setDurationUnit(selectedOption)
                // }
              }

              const handleconsumptionfrequencychange = (selectedOption) => {
                setMedicineDosageFrequency(selectedOption)
              };

              function handleRouteOfAdministration(selectedOption) {
                setRouteOfAdministration(selectedOption)
              }
              
              function handleTiming(e) {
                setTiming(e.target.value)
              }
              
              function handleQuantity(selectedOption) {
                setQuantity(selectedOption)
              }
              
              function handleAreaOfApplication(e) {
                setAreaOfApplication(e.target.value)
              }
              
              function handleDiluent(selectedOption) {
                setDiluent(selectedOption)
              }
              function handleAdditives(e) {
                setAdditives(e.target.value)
              }
              const handleMonthYearChange = (date) => {
                setMedicineExpiryDate(moment(date).format('MM-yyyy'));
              };
              const listOfSurgeonNames = ( isImage) => {
 
                const allSuggestions = treatmentteamdata && treatmentteamdata
              
                setSuggestions(allSuggestions);
                // setBoolValForSuggestions(!boolValForSuggestions) 
                if(isImage){
                  setShowDocNamesDropdown(!showDocNamesDropdown)
              
                }
              };
              const handleIsCurrent = (e)=>{
                if(e.target.checked){
                  setIsChecked(1)
                }else{
                  setIsChecked(0)
                }
              }
              const fileInputRef = useRef(null);
  const fileInputRefUpdate = useRef(null);
  const handleMedicationUpload = async (e) => {
    e.preventDefault();
    showLoader();

    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {
        
        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    //console.log(file2 , "File")
    const result = await uploadImageInProfile(file2, file2.name);
    //console.log(result , "result.name ");
    const filename = result.name;
    setFilenameArray(prev => [...prev, filename]);
    
    e.target.value = ''; 
    dismissLoader();

  };
              const addMedicationUploadDocument = () => {
                fileInputRef.current.click();
              }
                      
      const defaultStates = () => {
        setFilenameArray([]);
    setMedicineName("") 
    setComposition("") 
    // setFromDate(moment().format("DD-MM-yyyy"))
    // setToDate(moment().format("DD-MM-yyyy"))
    setHospitalname(null)
    setPrescribedBy(null)
    //setMedicineType("Tablet")
    //setMedicineDosageUnit("mg")
    setMedicineDosage(null)
    setMedicineDosageFrequency("1")
    setMorning("1")
    setAfternoon("0")
    setEvening("0")
    setNight("0")
    setBeforefood('1')
    setAfterfood('0')
    setMedicineFreqUnit("")
    setMedicineFreqValue(null)
    // setDurationUnit("")
    // setDurationValue("")
    setComposition("")
    setTimeValues(["morning"]);
  setFoodTiming("beforefood");
    setMedicineExpiryDate("")
    setShowAIModal(true);

      }
  
      const openAddMedicationModal = () => {
        defaultStates();
        addmedications.current.openRight();
      };

      const handlemedicinename = (event) => {
        setMedicineName(event.target.value);
      };
  
      //-------------saving data
    //   var inputForAdd = {
    //     medicalcondition: selectedConditions.map((condition) => ({
    //       conditiontype_cd: condition?.category?.conditiontype_cd,
    //       condition_cd: condition.condition_cd,
    //       nomenclatureid: condition.condition_cd,
    //       conditionidentifieddate: selectedDates[condition.condition_cd] || "",
    //       condition: condition.condition,
    //       conditiontype: condition.category.conditiontype,
    //     })),
    //     patientid: patientId,
    //   };

    const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

// ----------------------- multilingual -----------------------------
// waves 
   const recorderRef = useRef(null);
     const [chunks, setChunks] = useState([]);
       const [recording, setRecording] = useState(false);
     
    const [stream, setStream] = useState(null);

    useEffect(() => {
        if (recorderRef.current) return;
    
        if (navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
              setStream(stream);
    
              recorderRef.current = new MediaRecorder(stream);
              // audioContextRef.current = new AudioContext({
              //   sampleRate: WHISPER_SAMPLING_RATE,
              // });
    
              recorderRef.current.onstart = () => {
                setRecording(true);
                setChunks([]);
              };
              recorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) {
                  setChunks((prev) => [...prev, e.data]);
                } else {
                  setTimeout(() => {
                    recorderRef.current.requestData();
                  }, 25);
                }
              };
    
              recorderRef.current.onstop = () => {
                setRecording(false);
              };
            })
            .catch((err) => console.error("The following error occurred: ", err));
        } else {
          console.error("getUserMedia not supported on your browser!");
        }
    
        return () => {
          recorderRef.current?.stop();
          recorderRef.current = null;
        };
      }, []);
    

  // ------------------------------------
  //Remove speech and keep Null to toggle between GPU and Speech
  const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
  const [inpLang, setInpLang] = useState("English");
    const [instructions, setInstructions] = useState(null);
      const [editInstructions, setEditInstructions] = useState(null);

  
  function handleInstructions(value) {
    // console.log('e: ', e.target.value)
    setInstructions(value)
  }
  function handleEditInstructions(value) {
    // console.log('e: ', e.target.value)
    setEditInstructions(value)
  }
  
  const handleChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedLanguage(languageCode);
    console.log("Selected Language: ", selectedLanguage);
    console.log("Language Code: ", languageCode);
  };

  const [outLang, setOutputLang] = useState("English")
  const handleChangeOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; 
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputLang(selectedLanguage);
    console.log("Selected Language OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };
  const language = 'hi-IN';
const { transcriber: activeTranscriber, mode } =
  useHybridTranscriber("speech", (text) => {
    // called when speech recognition finishes
    setPlaceholder(text || "");
    setTyping(false);
},
SelectedLanguage
);
// Add this state to your parent component
const [isRecording, setIsRecording] = useState(false);

// Add this function to handle recording state changes
const handleRecordingStateChange = (recording) => {
  setIsRecording(recording);
};
// ----------------------- Add/Edit REcorder------------------------------
// const activeTranscriber = useGPUTranscriber();

  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
      const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [placeholder, setPlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );

  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isAddModalOpen]);
  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleEditInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isEditModalOpen]);

  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [initialText, setInitialText] = useState("");

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
     // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

const correctOrders = async (formType) => {
    // const currentText = watch("textField");
    let currentText = "";
  if (formType === "add") {
    currentText = instructions || "";
  } else if(formType === "edit") {
    currentText = editInstructions || "";
  }

  const getDoctorSpecialti = localStorage.getItem('doctorSpecialities')
  const getDoctorExp = localStorage.getItem('doctorExperience')
    
    if (!currentText) {
      showErrorToast("No text available to correct");
      return;
    }

    const inputToSave = {
      input: {
        text: currentText,
        type: `medicine_instructions#${getDoctorSpecialti}#${getDoctorExp}#ConsultationNote#${inpLang}#${outLang}`,
      },
    };

    showLoader();
    try {
      // const result = await CorrectInstructionsUsingAI(inputToSave.input);
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      if (result) {
        showSuccessToast("Updated Text");
        const updatedText = result?.text;

        if (formType === "add") {
        handleInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "edit") {
        handleEditInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      }      
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error in Correct AI call:", error);
      showErrorToast("Error Happened While Correcting.");
    } finally {
      dismissLoader();
    }
};
  
      return (
        <Box h='100%'>
          <Box
            bg="#fcfcfd"
            width={width}
            height={height}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
            h='100%'
            gap='1rem'
          >
            <PrimaryButton
              fontSize="14px"
              variant="mdBtn"
              btnIcon="/assets/imgs/add.png"
              buttonText="Add Medication"
              onClick={openAddMedicationModal}
              isDisabled={actionAccessPatients?.create ? false : true}
            />
            {isNoData === "Yes" &&
            <Text textAlign="center">
              No Medication Data Available
            </Text>
            }
          </Box>
          <>
          <ModalRight
        ref={addmedications}
        header="Add Medication"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="460px"
        body={
          <>
            <Box display="flex" flexDir="column" gap="20px">
              <Stack>
                <InputGroup>
                  <Input
                    pr="4.5rem" // Padding right to make room for the icon
                    type="text"
                    placeholder="Medicine name*"
                    value={medicinename}
                    sx={{
                      height: "48px",
                      borderRadius: "10px",
                      _hover: {
                        border: "2px solid",
                        borderColor: COLORS.INPUT_FOCUS_DARK,
                        outline: "none",
                        bg: "none",
                        _focus: {
                          borderRadius: "10px",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                        },
                        _focusVisible: { borderColor: "none" },
                      },
                    }}
                    onChange={handlemedicinename}
                    maxLength={80}
                  />
                  <InputRightElement width="4.5rem">
                    <Box
                      as="button"
                      h="1.75rem"
                      bg="none"
                      pt="8px"
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                      sx={{ _hover: { bg: "none" } }}
                    >
                      <Image src="/assets/svgs/image-search-blue.svg" />
                    </Box>
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                      //onChange={(e) => setFile(e.target.files[0])}
                      onChange={handleimageselection}
                    />
                  </InputRightElement>
                </InputGroup>
                <InputGroup>
                <PrimaryInput
                variant="bothSide"
                  inputValue={Composition}
                  onChange={(event)=> setComposition(event.target.value)}
                  inputPlace="Medicine Composition"
                />
                  {/* <PrimaryButton
                          buttonText="Fetch"
                          verticalAlign="bottom"
                          variant="grayBtn"
                          btnStyle={{
                            w: "15%",
                            color: COLORS.PRIMARY_COLOR,
                            verticalAlign: "bottom",
                            ml: "4px",
                            mb: "0px",
                            h: "48px",
                            m: "0",
                            borderRadius: "0 10px 10px 0",
                            opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                          
                          }}
                          onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                          // onClick={() =>
                          //   fetchComposition(medicinename)
                          // }
                          // isDisabled={false}

                        /> */}
                        <Box
                          as="button"
                          type="button"
                          border="1px solid #E6E7E9"
                          // borderRadius="full"
                          width={{ base: "100%", md: "10%" }}
                          // w="40px"
                          // h="40px"
                          p="8px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                          // opacity={medicineTextFieldValue ? 1 : 0.5}
                          // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                          onClick={() => {
                          if (isChatbotAllowed()) {
                            fetchComposition(medicinename);
                          } else {
                            showErrorToast("Please upgrade your subscription to use this feature");
                          }
                        }}
                        isDisabled={!isChatbotAllowed()}
                        title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                          bg="white"
                          // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                        >
                          <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                        </Box>
                        
                        </InputGroup>
                        {/* {medicinename != '' &&
                        <Box as="button" onClick={makeAicall} textAlign="right" fontSize="12px" textDecoration="underline">Learn more</Box>
                        } */}
                        <RadioGroup
                        mt="1rem"
                  // defaultValue={medicineTypeRadio}
                  // onChange={handlemedicinetypechange}
                  value={medicinetype || "Tablet"}
                onChange={handlemedicinetypechange}
                >
                   <Divider />
                  <Stack direction="row" alignItems='center' gap="20px"  wrap="wrap">

<Radio colorScheme="green" value="Tablet">Tablet</Radio>
                  <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                  <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                  <Radio colorScheme="green" value="Drops">Drops</Radio>
                  <Radio colorScheme="green" value="Injection">Injection</Radio>
                  <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                  <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                  <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                  <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                  <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                  <Radio colorScheme="green" value="Cream">Cream</Radio>
                  <Radio colorScheme="green" value="Gel">Gel</Radio>
                    {/* <Radio value="Tablet">Tablet</Radio>
                    <Radio value="Capsule">Capsule</Radio>
                    <Radio value="Syrup">Syrup</Radio>
                    <Radio value="Injection">Injection</Radio>
                    <Radio value="Ointment">Ointments / Creams / Gels</Radio>
                    <Radio value="Drops">Drops</Radio>
                    <Radio value="Nebulization">Nebulization</Radio>
                    <Radio value="IVFluids">IV Fluids</Radio>
                    <Radio value="Inhaler">Inhaler</Radio> */}
                  <Text>-Or-</Text>
                  <Box mx='1rem'>
                  <DropdownInput
                                            variant="bothSide"
                                            dropDownPlace="More Medicine Types"
                                            options={additionalMedicineTypes}
                                            onClick={(value) => handleDropdownMedTypeChange(value)}
                                            value={dropdownMedType}
                                            defaultOption={dropdownMedType || "Select more types"}
                                          />

                  </Box>
                  </Stack>
                </RadioGroup>
                <Divider />
                <Box>
                  {/* {medicinetype == "Tablet" && */}
                    {/* <MiniDropdownInput
                    variant="bothside"
                    options={ [
                    { label: "mg", value: "mg" },
                    { label: "ml", value: "ml" },
                      ] }
                    placeholderProp="Dosage"
                    onSelect={handleChangeDosageUnit}
                    defaultOptionProp={dosageunit}
                    handleInputChange={(e) =>
                      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                    }
                    inputVal={dosage}
                    
                    maxLength="6"
                  /> */}


{medicinetype == "Tablet" || medicinetype == "Capsule" || medicinetype == "Suppository" || medicinetype == "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Inhaler" || medicinetype === "Spray" || medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
      // { label: "grms", value: "grms" },
    ]}
    placeholderProp="Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Syrup" ||
    medicinetype === "IVFluids" ||
    medicinetype === "Nebulization" ||
    medicinetype === "Drops" ||
    medicinetype === "Injection" ||
    medicinetype === "Suspension" ||
    medicinetype === "Respules" ||
    medicinetype === "Gargle" ||
    medicinetype === "Shampoo" ||
    medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Ointment" ||
    medicinetype === "Cream" ||
    medicinetype === "Gel" ||
    medicinetype === "Foam" ||
    medicinetype === "Lotion" ||
    medicinetype === "Tube" ||
    medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    // options={[{ label: "grms", value: "grms" }]}
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Weight"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "EA" || medicinetype === "Device" || medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : (
  // Default case for CUSTOM and any unexpected types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={medicinetype === "Custom" ? "Custom Unit" : "Strength"}
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(
        validationOfNumberWithOnly1Decimal(e.target.value),
      )
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
)}
{/* existing latest */}
{/* {medicinetype == "Tablet" || medicinetype == "Capsule" ?
                (
                    <MiniDropdownInput
                    variant="bothside"
                    options={ [
                    { label: "mg", value: "mg" },
                    { label: "mcg", value: "mcg" },
                    { label: "g", value: "g" },
                    // { label: "ml", value: "ml" },
                    // { label: "grms", value: "grms" },
                      ] }
                
                    placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                    }
                    inputVal={dosage}

                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ): medicinetype === "Inhaler" ? (
                  <MiniDropdownInput
                    variant="bothside"
                    // options={[{ label: "puffs", value: "puffs" }]}
                    options={ [
                      { label: "puffs", value: "puffs" },
                      { label: "ml", value: "ml" },
                    { label: "grms", value: "grms" },
                      ] }
                
                    placeholderProp={medicinetype == "Inhaler" ? "Volume" :  "Strength"}
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                    }
                    inputVal={dosage}

                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : medicinetype === "Syrup" || medicinetype === "IVFluids" || medicinetype === "Nebulization" || medicinetype === "Drops" || medicinetype === "Injection" ? (
                  <MiniDropdownInput
                    variant="bothside"
                    // options={[{ label: "puffs", value: "puffs" }]}
                    options={ [
                      { label: "ml", value: "ml" },
                      ] }
                
                    placeholderProp={ medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                    }
                    inputVal={dosage}

                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                ) : (
                  <MiniDropdownInput
                    variant="bothside"
                    options={ [
                    { label: "mg", value: "mg" },
                    { label: "ml", value: "ml" },
                    { label: "grms", value: "grms" },
                      ] }
                
                    placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                    }
                    inputVal={dosage}

                    defaultOptionProp={dosageunit}
                    maxLength="6"
                  />
                )} */}
                  
                  {medicinetype == "IVFluids" &&

<MiniDropdownInput
  variant="bothside"
  options={[
    { label: "ml/hr", value: "ml/hr" },
    { label: "ml/min", value: "ml/min" },
    // { label: "grms/hr", value: "grms/hr" },
  ]}
  handleInputChange={(e) =>
    setRateOfInfusionValue(validationOfNumberWithOnly1Decimal(e.target.value))
  }
  placeholderProp={"Rate of Infusion"}
  onSelect={handleRateOfInfusionUnit}
  maxLength="6"
/>

}


{/* <Divider my="10px" />
  <Text  fontSize="0.875rem" fontWeight="500" mb="10px">{medicinetype == "Ointment" ? "Application Frequency" : "Frequency" }</Text> */}
  <DropdownInput
    variant="downSide"
    dropDownPlace={medicinetype == "Ointment" ? "Application Frequency" : medicinetype == "Nebulization" || medicinetype == "Inhaler" || medicinetype == "IVFluids" ? "Frequency" : "Consumption Quantity" }
    options={["0.5", "1", "2", "3", "4"]}
    onClick={handleconsumptionfrequencychange}
    // defaultOption="1"
    // defaultOption="1"
    // defaultOption={frequency}
    value={frequency}
  />
   {/* <DropdownInput
    variant="bothSide"
    dropDownPlace="Frequency Interval"
    options={["Hours","Days", "Weeks", "Months", "Years"]} // Interval units as options
    onClick={handleFrequencyUnit}
  /> */}
  
  <Divider my="10px" />


  {(medicinetype == "Injection" || medicinetype == "Tablet" ||medicinetype == "Capsule" ) &&
  <>
  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        // defaultOption={durationUnit}
        // defaultOption="Days"
        value={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        // defaultOption={durationValue}
        // defaultOption="5"
        value={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />
  </>
  }


{(medicinetype == "Injection") &&
<>


  <DropdownInput
    variant="downSide"
    dropDownPlace="Route of Administration"
    options={["Intravenous (IV)", "Intramuscular (IM)", "Subcutaneous (SC)"]}
    onClick={handleRouteOfAdministration}
  />
  <Box>
    <PrimaryInput
      variant={"bothSide"}
      onChange={handleTiming}
      inputPlace="Timing"
    />
  </Box>

</>
}

{(medicinetype == "Ointment") &&
<>

  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Application Duration</Text>
  <Box display="flex" flexDir="row">
    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
        onClick={handleDurationUnit}
        
        // defaultOption={durationUnit}
        defaultOption="Days"
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        
        // defaultOption={durationValue}
        defaultOption="5"
      />
    </Box>

  </Box>

  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Quantity"
    options={["Pea-sized", "Thin layer", "Fingertip unit (FTU)", "Half a fingertip"]}
    onClick={handleQuantity}
  />
  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAreaOfApplication}
    inputPlace="Area of Application"
  />
</>
}


{(medicinetype == "Nebulization") &&
<>

  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        // defaultOption={durationUnit}
        defaultOption="Days"

      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        // defaultOption={durationValue}
        defaultOption="5"
      />
    </Box>
  </Box>
  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Diluent"
    options={["Normal saline", "Distilled water" , "3% saline"]}
    onClick={handleDiluent}
  />

</>
}


{(medicinetype == "IVFluids") &&
<>
  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Infusion Duration</Text>

  <DropdownInput
    variant="downSide"
    dropDownPlace="Infusion frequency"
    options={["1", "2", "3", "4", "5", "6", "7",]}
    onClick={handleDurationValue}
    // defaultOption={durationValue}
    defaultOption="5"

  />
  <DropdownInput
    variant="bothSide"
    dropDownPlace="Infusion Duration"
    options={["Days", "Weeks", "Months", "Years"]}
    onClick={handleDurationUnit}
    // defaultOption={durationUnit}
    defaultOption="Days"

  />

  <Divider my="10px" />

  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAdditives}
    inputPlace="Additives"
  />


</>
}

{(medicinetype == "Inhaler") &&
                                      <>
                  
                                        {/* <Divider my="10px" /> */}
                                        <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>
                  
                                        <Box display="flex" flexDir="row">
                  
                                          <Box width="50%">
                                            <DropdownInput
                                              variant="bothSide"
                                              dropDownPlace="Duration"
                                              options={["Days", "Weeks", "Months", "Years"]}
                                              onClick={handleDurationUnit}
                                              // defaultOption={durationUnit}
                                              defaultOption="Days"

                                            />
                                          </Box>
                                          <Box width="50%">
                                            <DropdownInput
                                              variant="downSide"
                                              dropDownPlace="Interval Value"
                                              options={["1", "2", "3", "4", "5", "6", "7",]}
                                              onClick={handleDurationValue}
                                              // defaultOption={durationValue}
                                              defaultOption="5"
                                            />
                                          </Box>
                                        </Box>
                                        <Divider my="10px" />
                  
                                      </>
                                    }

                  {/* <PrimaryInput
                    inputPlace="Medicine Expiry"
                    variant="defaultSide"
                    inputValue={medicineexpirydate}
                    onChange={(event) => handleExpiryDateChange(event.target.value)}
                  /> */}

                  <MonthYearPicker
                    placeholderProp="Medicine Expiry"
                    value={medicineexpirydate}
                    onDateChange={handleMonthYearChange}
                    datePickerInputStyle={{ borderRadius: "0 0 10px 10px" }}
                    minYear={moment().year()}
                  // minDate={moment().startOf('month')}

                  />
                  <CheckboxGroup
                    colorScheme="green"
                    onChange={handlemedicinetime}
                    value={timeValues}
                  >
                    <Stack spacing={2} pt="20px" direction="row">
                      <Checkbox value="morning">Morning</Checkbox>
                      <Checkbox value="afternoon">Afternoon</Checkbox>
                      {/* <Checkbox value="evening">Evening</Checkbox> */}
                      <Checkbox value="night">Night</Checkbox>
                    </Stack>
                  </CheckboxGroup>

                  <Text fontWeight='600' width="100%" display='flex' justifyContent='center' whiteSpace='nowrap'>- Or -</Text>
                  
                  <Box display='flex'>


                      <Box width='50%'>
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Frequency"
                          options={["Hours", "Daily", "Weekly"]}
                          onClick={handleFrequencyUnit}   
                          value={medicineFreqUnit}             
                          // defaultOption={"Hours"}
                          // value={newMedicine.frequencytime || ""}
                        />
                      </Box>
                      <Box width='50%'>
                      <DropdownInputForVitals
                          variant="bothSide"
                          dropDownPlace="Value"
                          options={["1", "2", "3", "4", "8"]}
                          onClick={handleFrequencyValue} 
                          value={medicineFreqValue} 
                          readOnly=""
                          inputValueProp={medicineFreqValue}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value) {
                              setTimeValues([]);
                              setMorning(0);
                              setAfternoon(0);
                              setNight(0);
                            }
                            setMedicineFreqValue(value);
                          }}           
                          maxLength={2} 
                          // defaultOption={"Hours"}
                          // value={newMedicine.frequencytime || ""}
                        />
                      </Box>
                  </Box>
                  
                      {/* <Box width='80px'>
                        <DropdownInput
                          variant="bothSide"
                          dropDownPlace="Value"
                          options={["1", "2", "3", "4", "8"]}
                          onClick={(value) => {
                            // Uncheck time checkboxes when selecting value
                            if (value) {
                              handleNewMedicineChange("morning", 0);
                              handleNewMedicineChange("afternoon", 0);
                              handleNewMedicineChange("night", 0);
                            }
                            handleNewMedicineChange("frequencyvalue", value || "");
                          }}
                          onChange={(e) => {
                            // Handle manual text input for value
                            const value = e.target.value;
                            if (value) {
                              handleNewMedicineChange("morning", 0);
                              handleNewMedicineChange("afternoon", 0);
                              handleNewMedicineChange("night", 0);
                            }
                            handleNewMedicineChange("frequencyvalue", value || "");
                          }}
                          value={newMedicine.frequencyvalue}
                        />
                      </Box> */}

                  {/* <DropdownInput
    variant="bothSide"
    dropDownPlace="Frequency"
    options={["Hours","Days", "Weeks", "Months", "Years"]} // Interval units as options
    onClick={handleFrequencyUnit}
  /> */}
                  {/* <Divider /> */}
                  {/* <CheckboxGroup
                    colorScheme="green"
                    onChange={handlemedicinetimebeforeafter}
                  >
                    <Stack spacing={2} pt="20px" direction="row">
                      <Checkbox value="beforefood">Before Food</Checkbox>
                      <Checkbox value="afterfood">After Food</Checkbox>
                    </Stack>
                  </CheckboxGroup> */}

<RadioGroup 
  colorScheme="green" 
  onChange={handlemedicinetimebeforeafter} 
  value={foodTiming}
>
  <Stack spacing={2} pt="20px" direction="row">
    <Radio value="beforefood">Before Food</Radio>
    <Radio value="afterfood">After Food</Radio>
  </Stack>
</RadioGroup>
                  {/* <Divider /> */}
                  
                </Box>
                {/* <Divider /> */}
                <Box>
                <Box w="100%" pos='relative' cursor="pointer">
                  <PrimaryInput
                    inputPlace="Prescribed by"
                    variant="defaultSide"
                    inputValue={prescribedby}
                    onChange={(e) =>
                      handleSurgeonNameChange(handleAlphaDotAndSpace(e.target.value,50))
                    }
                    onClick={() =>
                      listOfSurgeonNames(false)
                    }
                inputIdProp={"DoctorNameInAdd"}
                boolProp={boolValForSuggestions}
                  />
                    <Image top="33%" right="6.5%" w="15px" 
                          onClick={() =>
                            listOfSurgeonNames( true)
                          }
                            pos='absolute' src="/assets/imgs/double-arrow.png" />
                          
                  </Box>
                    {showDocNamesDropdown &&  suggestions.length > 0 && (
                <Menu isOpen={true}>
                <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
                  <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
                </MenuButton>
                <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
                  {suggestions.map((suggestion, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleSelect(suggestion)}
                      cursor="pointer"
                      p="1rem"
                      py="0.5rem"
                      borderBottom="1px solid #E6E7E9"
                    >
                      <Text fontSize="0.875rem" fontWeight="500">{suggestion.doctorname}</Text>
                    </MenuItem>
                  ))}
                  </MenuList>
                </Menu>
              )}


                  <PrimaryInput
                    inputPlace="Hospital name"
                    variant="downSide"
                    onChange={(e) => setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))}
                    inputValue={hospitalname}
                  />
                  <Box mt="15px">
                  <Checkbox
                colorScheme="green"
                sx={{
                  ".chakra-checkbox__control": {
                    width: "20px",
                    height: "20px",
                    borderRadius: "5px",
                  },
                }}
                onChange={handleIsCurrent}
              >
                  Current
              </Checkbox>
              </Box>
                </Box>

                <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                  <Box
                    as="form"
                    width='100%'
                    bg="white"
                    pt={"2px"}
                  >
                    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                      <Textarea
                        borderRadius='0'
                        // value={newMedicine.custommessage || ''}
                        value={instructions || ''}
                        onChange={(e) => {
                    handleInstructions(e.target.value);
                    setValue("textField", e.target.value); 
                  }}
                        height="100%"
                        padding="2"
                        resize="none"
                        // disabled={typing} // Disable when AI typing is true
                        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                      />                      
                      {!instructions && (
                        <Text
                          position="absolute"
                          bottom="2"
                          left="50%"
                          transform="translateX(-50%)"
                          fontSize="sm"
                          color="gray.500"
                          w={{ base: "100%", md: "unset" }}
                          textAlign={{ base: "center", md: "unset" }}
                        >
                          {placeholder}
                        </Text>
                      )}
                    </Box>
                    
                  </Box>
                </Box>
                {/* Audio & Language Controls Row - Highlighted Section */}
<Box
  bg="#f8f9fa"
  border="1px solid #e9ecef"
  borderRadius="8px"
  p="1rem"
  mt="1rem"
>
  <Flex
    alignItems="center"
    justifyContent="space-between"
    gap="0.5rem"
    flexWrap={{ base: "wrap", md: "nowrap" }}
  >
    {/* Input Language Dropdown */}
    <Box flex="1" minW="100px"> {/* Reduced min width */}
      <DropdownWithMultiLingual 
        menuList={{pos:'relative', right:'75px'}}
        placeholder="English"
        onClick={handleChangeLanguage}
        options={languageOptions.map(value => ({ value }))}
        title="Input Language"
      />
    </Box>
    
    {/* Audio Controls and Wave Display - FIXED FOR SMALL WIDTH */}
    <Box 
      flex="none" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      gap="0.5rem" 
      minH="40px" 
      px="0.5rem" 
    >
      <GPUChatAudioManagerSpeechMode
        transcriber={activeTranscriber}
        mode={mode}
        setPlaceholder={setPlaceholder}
        setTyping={setTyping}
        onRecordingStateChange={handleRecordingStateChange} 
      />
      
      {/* Wave display with conditional rendering but maintaining space */}
      <Box 
        width={isRecording ? "150px" : "0"} 
        minW={isRecording ? "150px" : "0"}
        maxW={isRecording ? "200px" : "0"}
        height="30px"
        opacity={isRecording ? 1 : 0}
        transition="all 0.3s ease"
        overflow="hidden"
      >
        {isRecording && stream && (
          <AudioDisplayForClutter
            borderRadius="lg"
            stream={stream}
            width="100%"
            height="100%"
          />
        )}
      </Box>
    </Box>

    {/* Output Language Dropdown */}
    <Box flex="1" minW="100px"> {/* Reduced min width */}
      <DropdownWithMultiLingual 
        menuList={{pos:'relative', right:'75px'}}
        placeholder="English"
        onClick={handleChangeOutputLanguage}
        options={languageOptions.map(value => ({ value }))}
        title="Output Language"
      />
    </Box>

    {/* AI Correction Button */}
    <Box
      as="button"
      type="button"
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="35px"
      h="35px"
      p="6px" 
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor={textFieldValue ? "pointer" : "not-allowed"}
      opacity={textFieldValue ? 1 : 0.5}
      pointerEvents={textFieldValue ? "auto" : "none"}
      onClick={() => textFieldValue && correctOrders("add")}
      flexShrink="0"
      bg="white"
      _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
    >
      <Image w="24px" src="/assets/svgs/ai-star-outline.svg" /> {/* Smaller icon */}
    </Box>
  </Flex>
</Box>

                {filenameArray.map((filename, indexToDelete) => (
                  <Button fontSize="14px" fontWeight="500" w="100%" h="48px" borderRadius="10px" border="1px solid #E6E7E9" display="flex" justifyContent="space-between" bg="white" color="#1C4EC5" sx={{ _hover: { bg: "none" } }}>
                    Document {indexToDelete + 1}
                    {/* <Box display='flex' gap='10px'>
                    <Box as="span" onClick={() => window.open()}>
                      <Image h='16px' w='16px' src="/assets/imgs/show-pass.png" />
                    </Box> */}
                    <Box as="span" 
                    // onClick={() => handleDelete(indexToDelete)}
                    >
                      <Image src="/assets/imgs/delete.png" />
                    </Box>
                    {/* </Box> */}
                  </Button>
                ))}
                {/* <Box onClick={addMedicationUploadDocument} as="button" display="flex" alignItems="center" gap="10px" fontSize="14px" fontWeight="600" color="#1C4EC5" textAlign="left">
                  <Image w="11px" src="/assets/imgs/add-blue.png" />
                  Add Document
                </Box> */}
                <input
                  type='file'
                  id='file-upload'
                  onChange={(e) => handleMedicationUpload(e)}
                  ref={fileInputRef} // Set the ref for the file input
                  style={{ display: 'none' }} // Hide the file input
                />
              </Stack>
            </Box>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" flexDirection="row" gap="15px">
              <PrimaryButton
                buttonText="Add Medication"
                onClick={addmedicine}
              isDisabled={actionAccessPatients?.create ? false : true}
              />
            </Box>
          </>
        }
      />
          </>
        </Box>
      );
    }
  );
  
  export default NoMedicationDataScreen;
  